import Page from '@/components/Page'
import PostList from '@/components/Post/PostList'
import { PostListContext } from '@/components/Post/PostListContext'
import { getTopicFeedQueryOptions } from '@/utils/fetchers/topic'
import usePosts from '@/utils/hooks/usePosts'
import { prepareToRefetchListQuery } from '@/utils/list'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useMemo } from 'react'

export default function TopicPostPage({ id, tab }: { id: string; tab: string }) {
	const {
		data = {
			pages: [],
			pageParams: [],
		},
		fetchNextPage,
		refetch,
		isLoading,
		isFetchingNextPage,
	} = useInfiniteQuery(getTopicFeedQueryOptions(id, tab))
	const postIds = useMemo(() => data.pages.flatMap((page) => page.data), [data.pages])
	const posts = usePosts(postIds)

	const refresh = useCallback(() => {
		prepareToRefetchListQuery(getTopicFeedQueryOptions(id, tab).queryKey)
		return refetch()
	}, [refetch, id, tab])

	return (
		<Page>
			<PostListContext.Provider value={{ type: 'TOPIC' }}>
				<PostList
					data={posts}
					isLoading={isLoading || isFetchingNextPage}
					onLoadMore={async () => void (await fetchNextPage())}
				/>
			</PostListContext.Provider>
		</Page>
	)
}
